/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Playlist } from './Playlist';
import {
    PlaylistFromJSON,
    PlaylistFromJSONTyped,
    PlaylistToJSON,
} from './Playlist';

/**
 * 
 * @export
 * @interface PlaylistResponse
 */
export interface PlaylistResponse {
    /**
     * 
     * @type {Array<Playlist>}
     * @memberof PlaylistResponse
     */
    data?: Array<Playlist>;
}

/**
 * Check if a given object implements the PlaylistResponse interface.
 */
export function instanceOfPlaylistResponse(value: object): value is PlaylistResponse {
    let isInstance = true;

    return isInstance;
}

export function PlaylistResponseFromJSON(json: any): PlaylistResponse {
    return PlaylistResponseFromJSONTyped(json, false);
}

export function PlaylistResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlaylistResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(PlaylistFromJSON)),
    };
}

export function PlaylistResponseToJSON(value?: PlaylistResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(PlaylistToJSON)),
    };
}

